import React, { useState } from 'react';
import { Fab, Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useMedicationCart } from '../../contexts/MedicationCartContext';
import { CartDrawer } from './CartDrawer';


export const CartFab: React.FC = () => {
  const { itemCount } = useMedicationCart();
  const [open, setOpen] = useState(false);

  if (itemCount === 0) return null;

  return (
    <>
      <Fab
        aria-label="Abrir carrito"
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: { xs: 'calc(72px + env(safe-area-inset-bottom))', md: 24 },
          right: 16,
          bgcolor: 'primary.main',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0,102,204,0.35)',
          zIndex: (theme) => theme.zIndex.appBar + 1,
          '&:hover': { bgcolor: 'primary.dark' },
        }}
      >
        <Badge
          badgeContent={itemCount}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: 12,
              fontWeight: 700,
              minWidth: 22,
              height: 22,
            },
          }}
        >
          <ShoppingCartIcon />
        </Badge>
      </Fab>
      <CartDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};
